import { render, staticRenderFns } from "./NoteCardStack.vue?vue&type=template&id=e84ee0a8&scoped=true"
import script from "./NoteCardStack.vue?vue&type=script&lang=js"
export * from "./NoteCardStack.vue?vue&type=script&lang=js"
import style0 from "./NoteCardStack.vue?vue&type=style&index=0&id=e84ee0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84ee0a8",
  null
  
)

export default component.exports